import React, { useState } from "react";
import styles from "./security.module.css";
import InvestorForm from "../../../../common/investorForm/InvestorForm";
import { ReactComponent as Sec1 } from "../../../../../assests/security/sec1.svg";
import { ReactComponent as Sec2 } from "../../../../../assests/security/sec2.svg";
import { ReactComponent as Sec3 } from "../../../../../assests/security/sec3.svg";
import { ReactComponent as Sec4 } from "../../../../../assests/security/sec4.svg";
function Security() {
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  // const toggleMenu = () => {
  //   setShow(!show);
  // };
  // const navigate = useNavigate();
  // const handleClick = () => {
  //   navigate("/contact");
  // };
  // const location = useLocation();
  return (
    <div className={styles.security_wrapper}>
      <div className={styles.security_container}>
        {/* <h4>SHAPE THE FUTURE WITH US </h4> */}
        {/* <h4>Shape the Future with Us</h4> */}
        <div className={styles.upperCard}>
          <section className={styles.upperCardSection}>
            <div className={styles.expertGuidance}>
              <Sec1 className={styles.globalIcon} width={60} height={60} />
            </div>
            <div className={styles.upperCard_text}>
              <h2>Expert Guidance</h2>
              <p>
                Access personalized support and certifications from industry
                experts to strengthen your business strategy.{" "}
              </p>
            </div>
          </section>
          <section className={styles.upperCardSection}>
            <div className={styles.anonymity}>
              <Sec2 className={styles.globalIcon} width={70} height={70} />
            </div>
            <div className={styles.upperCard_text}>
              <h2>Anonymity</h2>
              <p>
                Our technology guarantees strong anonymity, requiring only an
                email for transactions, with no personal data ever shared.
              </p>
            </div>
          </section>
          <section className={styles.upperCardSection}>
            <div className={styles.synchronization}>
              <Sec3 className={styles.globalIcon} width={60} height={60} />
            </div>
            <div className={styles.upperCard_text}>
              <h2>Synchronization</h2>
              <p>
                Effortlessly manage your data with a clean, detailed admin
                dashboard that instantly synchronizes across all your devices.
              </p>
            </div>
          </section>
          <section className={styles.upperCardSection}>
            <div className={styles.professionalCredentials}>
              <Sec4 className={styles.globalIcon} width={70} height={70} />
            </div>
            <div className={styles.upperCard_text}>
              <h2>Professional Credentials</h2>
              <p>
                Our platform offers industry-recognized certifications,
                empowering businesses and professionals to excel in their
                fields.
              </p>
            </div>
          </section>
        </div>
        <div className={styles.upperIMG}></div>
        <div className={styles.lowerCard}>
          <div className={styles.price}>
            <p>
              <span className={styles.priceP}>Join</span> <br />{" "}
              <span>For</span>
            </p>
            <h2>
              Exclusive <br /> Benefits
            </h2>
            <button onClick={handleOpenModal} className={styles.joinBTN}>
              Join
            </button>
          </div>
          <div className={styles.price}>
            <p>
              <span className={styles.priceP}>Enhance </span> <br />{" "}
              <span>Your</span>
            </p>
            <h2>
              Portfolio <br /> Now!
            </h2>
            <button className={styles.enhanceBTN}>Enhance</button>
          </div>
          <div className={styles.price}>
            <p>
              <span className={styles.priceP}>Maximize </span>
              <br /> <span>your</span>
            </p>
            <h2>
              Potential <br /> Today!
            </h2>
            <button className={styles.maximizeBTN}>Maximize</button>
          </div>
          <div className={styles.price}>
            <p>
              <span className={styles.priceP}> Secure </span>
              <br /> <span>your</span>
            </p>
            <h2>
              Future
              <br /> Now!
            </h2>
            <button className={styles.secureBTN}>Secure</button>
          </div>
        </div>
        <div className={styles.lowerIMG}></div>
        <div className={styles.warning}>
          <h3>Invest in Innovation & Growth</h3>
          <p>
            Join a rapidly growing digital platform designed for scalability and
            long-term success. Our innovative solutions drive market demand,
            creating a unique investment opportunity. While we encourage due
            diligence, our vision and technology position us for significant
            growth. Invest in a future-focused business with strong potential.
          </p>
        </div>
        {/* Distributor Form Modal */}
        {showModal && <InvestorForm onClose={handleCloseModal} />}
      </div>
    </div>
  );
}

export default Security;
